import type { ReactElement } from 'react'

import { cn } from '@/lib/utils'

interface SwitchProps {
  checked: boolean
  onCheckedChange?: (checked: boolean) => void
  disabled?: boolean
  label: string
  className?: string
}

/**
 * Figma `switch` (999:18450) — 40×24 track, 4px padding, 16px knob.
 * Disabled + on renders the muted red used for "always active" rows.
 */
export function Switch({
  checked,
  onCheckedChange,
  disabled = false,
  label,
  className,
}: SwitchProps): ReactElement {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => {
        onCheckedChange?.(!checked)
      }}
      className={cn(
        'flex h-[24px] w-[40px] max-w-[48px] shrink-0 items-center rounded-full p-1 transition-colors',
        checked
          ? disabled
            ? 'bg-switch-on-disabled justify-end'
            : 'bg-switch-on justify-end'
          : 'bg-switch-off justify-start',
        disabled ? 'cursor-not-allowed' : 'cursor-pointer',
        className,
      )}
    >
      <span className="bg-switch-knob size-[16px] shrink-0 rounded-full" />
    </button>
  )
}
